import * as React from 'react';

import type { DialogTitleProps as MUIDialogTitleProps } from '@mui/material';
import { DialogTitle } from '@mui/material';

export interface DialogHeaderProps {
  /** 대화상자 헤더에 표시할 구성 요소다. */
  children?: React.ReactNode;
  /** 기본 구분선과 여백 뒤에 합성할 추가 스타일이다. */
  sx?: MUIDialogTitleProps['sx'];
}

export const lookoDialogHeaderClassName = 'LookoDialogHeaderV2';

/**
 * 공통 구분선과 여백을 적용한 대화상자 헤더를 렌더링한다.
 *
 * @param props 헤더 내용과 추가 스타일
 * @returns 공통 헤더 스타일이 적용된 대화상자 제목 영역
 */
export default function DialogHeader({ children, sx }: DialogHeaderProps) {
  return (
    <DialogTitle
      variant="H2_Looko"
      className={lookoDialogHeaderClassName}
      sx={[
        { borderBottom: theme => `1px solid ${theme.palette.divider}`, px: 4, py: 2.5 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </DialogTitle>
  );
}
